import type { IOrganizationOwnershipType } from '@patsnap/synapse_common_interface'
import { IFieldLangMap } from '@pharmsnap/shared/types'

export const ORG_ENTITY_LANG: IFieldLangMap = {
  Education: {
    cn: '教育机构',
    en: 'Education',
    jp: '教育機関',
  },
  Government: {
    cn: '政府',
    en: 'Government',
    jp: '政府機関',
  },
  Company: {
    cn: '公司',
    en: 'Company',
    jp: '企業',
  },
  Nonprofit: {
    cn: '非盈利组织',
    en: 'Nonprofit',
    jp: '非営利団体',
  },
  Hospital: {
    cn: '医院',
    en: 'Hospital',
    jp: '病院',
  },
}

/**
 * 机构所有权类型的日文文案。
 * 上游 OrganizationTypeTextRecord 只提供中文,英文直接取枚举值本身,故日文在此本地补充
 */
export const ORG_OWNERSHIP_TYPE_JP: Record<IOrganizationOwnershipType, string> = {
  Public: '上場企業',
  Holding: '持株会社',
  'Joint Venture': '合弁会社',
  Private: '非上場企業',
  Subsidiary: '子会社',
}
